import { Alert } from "react-bootstrap";
import { RenewalActions } from "../../../types/Order/RenewalEmail";

interface RenewalMessageProps {
  redirectParam: string;
}

const RenewalMessage = ({ redirectParam }: RenewalMessageProps) => {
  const isRenewal =
    redirectParam.includes(RenewalActions.RenewCurrent) ||
    redirectParam.includes(RenewalActions.RenewLatest);
  const isDeletion = redirectParam.includes(RenewalActions.RemoveData);

  if (!isRenewal && !isDeletion) return null;

  return (
    <>
      {isRenewal && (
        <Alert variant="info">Please login to renew your data.</Alert>
      )}
      {isDeletion && (
        <Alert variant="warning">Sign in to confirm data deletion.</Alert>
      )}
    </>
  );
};

export default RenewalMessage;
